import { LocalizableVideo, CfVideoState } from 'models/cms/common/types';
import findAvailableLocale from './findAvailableLocale';

const getVideoUrlByLocale = (video: LocalizableVideo, locale: string) => {
  let videoUrl: string = findAvailableLocale(video, locale)?.playbackUrl;
  const cfState: CfVideoState = findAvailableLocale(video, locale)?.cfState;
  const cfHlsUrl: string = findAvailableLocale(video, locale)?.cfHlsUrl;
  if (cfHlsUrl && cfState === CfVideoState.Ready) {
    videoUrl = `${cfHlsUrl}`;
  }
  return videoUrl;
};

export default getVideoUrlByLocale;
